module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kWzTD"))).then(() => parcelRequire('ikE14'));